/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { FaHeart } from 'react-icons/fa';
import { useField } from 'formik';

function FavouriteField({ name }) {
  const [field,, helpers] = useField(name);

  function handleClick() {
    helpers.setValue(!field.value)
  }

  return (
    <div className="favourite-field" onClick={handleClick}>
      <span className={`heart-button${  field.value ? ' active' : ''}`}>
        <FaHeart />
      </span>
      nastavit jako výchozí
    </div>
  );
}

export default FavouriteField;
